import styled from "styled-components";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";

const ProfileMessagesDefaultBox = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 1rem;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        margin: 0.5rem 0;
        padding: 0;
    }
`;

const ProfileMessagesCasino777Box = styled(ProfileMessagesDefaultBox)`
    padding: 0.5rem 0;
    background: ${({theme}) => theme.colors.brandPrimary };

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        background: transparent;
    }
`;

export const ProfileMessagesBox = styledByTheme(ProfileMessagesDefaultBox)
    .forCasino777(ProfileMessagesCasino777Box)
    .apply();
